
export default () => {
  document.addEventListener('DOMContentLoaded', () => {
    const images = document.querySelectorAll('.p-mainvisual__image');
    if (images.length >= 2) {

      const time = 4000;
      const time2 = time + 1100;
      const images = document.querySelectorAll('.p-mainvisual__image');
      let currentIndex = 0;

      function showSlide(index) {
        images.forEach((img, i) => {
          // img.classList.remove('is-visible', 'is-view');
          if (i === index) {
            img.classList.add('is-visible', 'is-view');

            // 4秒後にis-visibleを削除
            setTimeout(() => {
              img.classList.remove('is-visible');
            }, time); // 4秒後にis-visibleを削除

            // 5秒後にis-viewを削除
            setTimeout(() => {
              img.classList.remove('is-view');
            }, time2); // 5秒後にis-viewを削除
          }
        });
      }

      function nextSlide() {
        currentIndex = (currentIndex + 1) % images.length;
        showSlide(currentIndex);
      }

      // 初期化: 最初のスライドを表示
      showSlide(currentIndex);

      // 4秒ごとに次のスライドへ
      setInterval(nextSlide, time);
    }
  });
}
